module.exports = __webpack_public_path__ + "media/src/images/landing_icons/landing_features-06-dfefd847845b7b6beef89f74ad595f3c.svg";